import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelClientsAddCorporateResolverErrorStatesEnum {
    GetCountriesFailed = ErrorStateScheduleEnum.PanelClientsAddCorporateResolverStatesStartIndex,
    GetCountriesInvalidData,
    GetCompanyFailed,
    GetAssignedPortalsFailed,
    GetAssignedPortalsInvalidData
}
